import { MatToolbarModule } from '@angular/material/toolbar';
import { NgModule } from '@angular/core';
import { MoveElementComponent } from './move-element.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { FormioModule } from '@formio/angular';
import { TranslateModule } from '@ngx-translate/core';
import {
    FuseSharedModule,
    LayoutModule,
    FuseSidebarModule,
} from 'sp-office365-layout';
import { DurationTimeModule } from '../../time/duration-time/duration-time.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
    declarations: [MoveElementComponent],
    imports: [
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        MatIconModule,
        MatTabsModule,
        FuseSidebarModule,
        FormioModule,
        FormioModule,
        DurationTimeModule,
        MatToolbarModule,
        DragDropModule,
    ],
})
export class MoveElementModule {}
